import {useInViewEffect} from '@aboutyou/ui-components';
import React from 'react';

interface OnLoadTriggerTileProps {
  callback?: () => void;
}

export const OnLoadTriggerTile = ({callback}: OnLoadTriggerTileProps) => {
  const {ref} = useInViewEffect<HTMLDivElement>(
    inView => {
      if (inView) {
        callback?.();
      }
    },
    {
      threshold: 0.01,
      triggerOnce: true,
    },
  );

  return <div ref={ref} data-testid="push-notification-load-trigger"></div>;
};
